import {
    useQuery,
    UseQueryOptions,
    UseQueryResult,
    QueryFunctionContext,
    QueryKey,
} from '@tanstack/react-query';

/**
 * Hook to creates a custom useQuery hook with pre-defined generic types.
 *
 * @template TQueryKey - Type of the query key.
 */
const createCustomUseQuery =
    <TQueryKey extends QueryKey>() =>
    <TQueryFnData = unknown, TError = unknown, TData = TQueryFnData>(
        queryKey: TQueryKey,
        queryFn: (
            context: QueryFunctionContext<TQueryKey>,
        ) => Promise<TQueryFnData>,
        options?: Partial<
            UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>
        >,
    ): UseQueryResult<TData, TError> =>
        useQuery<TQueryFnData, TError, TData, TQueryKey>({
            queryKey,
            queryFn,
            ...options,
        });

export default createCustomUseQuery;
